'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var formatNumber = function () {
    function formatNumber(filter) {
        var _this = this;

        _classCallCheck(this, formatNumber);

        this.filter = filter;
        this.require = '?ngModel';
        this.link = function (scope, elem, attrs, ctrl) {
            if (!ctrl) return;

            ctrl.$formatters.unshift(function () {
                var valueInFormatter = _this.filter('number')(ctrl.$modelValue);
                return valueInFormatter;
            });

            ctrl.$parsers.unshift(function (goog) {
                var plainNumber = goog.replace(/[\,\.]/g, '');
                var formattedNumber = _this.filter('number')(plainNumber);
                formattedNumber = convertZeroToEmptyString(formattedNumber);
                elem.val(formattedNumber);
                return plainNumber;
            });

            function convertZeroToEmptyString(formattedNumber) {
                if (formattedNumber === '0') return '';else return formattedNumber;
            }
        };
    }

    /**
     * Factory
     * @return {Object}
     */


    _createClass(formatNumber, null, [{
        key: 'directiveFactory',
        value: function directiveFactory($filter) {
            formatNumber.instance = new formatNumber($filter);
            return formatNumber.instance;
        }
    }]);

    return formatNumber;
}();

exports.default = formatNumber;


/** WEBPACK FOOTER **
 ** ./src/app/directives/common/formatNumber.js
 **/